export function normalizeLocalizedField(value) {
  if (value === null || value === undefined) {
    return {}
  }
  if (Array.isArray(value)) {
    return {}
  }
  if (typeof value === 'object') {
    return { ...value }
  }
  return {}
}

function collectLocaleKeys(question, langs = []) {
  const locales = new Set(langs)

  getLocaleKeysFromField(question?.body).forEach((key) => locales.add(key))
  getLocaleKeysFromField(question?.correct).forEach((key) => locales.add(key))
  ;(question?.answers || []).forEach((answer) => {
    getLocaleKeysFromField(answer?.body).forEach((key) => locales.add(key))
  })

  return [...locales]
}

function getLocaleKeysFromField(field) {
  return Object.keys(normalizeLocalizedField(field))
}

export function normalizeQuestion(question, langs = []) {
  if (!question || typeof question !== 'object') {
    return question
  }

  const normalized = { ...question }
  const body = normalizeLocalizedField(normalized.body)
  const correct = normalizeLocalizedField(normalized.correct)
  const locales = collectLocaleKeys(normalized, langs)

  locales.forEach((code) => {
    if (body[code] === undefined || body[code] === null) {
      body[code] = ''
    }
  })

  normalized.body = body
  normalized.correct = correct
  normalized.answers = (normalized.answers || []).map((answer) => {
    const answerBody = normalizeLocalizedField(answer?.body)

    locales.forEach((code) => {
      if (answerBody[code] === undefined || answerBody[code] === null) {
        answerBody[code] = ''
      }
    })

    return { ...answer, body: answerBody }
  })

  return normalized
}

export function normalizeQuestions(questions, langs = []) {
  if (!Array.isArray(questions)) {
    return []
  }

  return questions.map((question) => normalizeQuestion(question, langs))
}

export function getQuestionBodyText(question, locale) {
  const body = normalizeLocalizedField(question?.body)

  if (locale && body[locale]?.trim()) {
    return body[locale]
  }

  const first = Object.values(body).find((text) => text?.trim())
  return first || ''
}
